const Info = ({ active, event, id, title, content, parentIsActive }) => {
  const descriptions = content.split('.');
  descriptions.pop();
  return (
    <div className="Tooltip-text">
      <h5> {title} </h5>
      <p className="">
        {descriptions.map((des, i) => (
          <span key={i}>
            {des.toString()} <br />
            <br />
          </span>
        ))}
      </p>
    </div>
  );
};

export default Info;
